export const addNewShiftRoute = '/addNewShift';
export const addNewShiftWizardRoute = '/addNewShiftWizard';
